import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyDIacDnk-tsGdeabKQDb9hkVUuAe96EJIc",
  authDomain: "calloc-16525.firebaseapp.com",
  databaseURL: "https://calloc-16525-default-rtdb.firebaseio.com",
  projectId: "calloc-16525",
  storageBucket: "calloc-16525.firebasestorage.app",
  messagingSenderId: "577080170042",
  appId: "1:577080170042:web:8545cb1ed6dd74edc30703",
  measurementId: "G-20J23WPQZ7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Analytics (optional)
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export default app;
